
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/extension",
      function () {
        return require("private-next-pages/extension/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/extension"])
      });
    }
  